import emailsMatch from './emailsMatch'
import shouldResumePostLoginAttach from './shouldResumePostLoginAttach'

// EditMemberContactInfo mount: keep Sign-in leftovers only for a real
// post-Auth0 resume. Otherwise tell the caller to clear LS so a stale
// form cannot prefill and a leftover lookup cannot pair later.
function resolveEditJoinSignInSnapshots({
  disableEmail = false,
  savedFormValues = null,
  resumedExistingContact = null,
  userEmail = null,
}) {
  // Guest / renewal: drop an abandoned SIGN_IN pair. Leave lookup-only —
  // confirmation uses it for the Log In CTA after Proceed as Guest.
  if (!disableEmail) {
    return {
      savedFormValues: null,
      resumedExistingContact: null,
      clearSnapshots: !!savedFormValues,
    }
  }

  if (
    shouldResumePostLoginAttach({
      disableEmail: true,
      savedFormValues,
      resumedExistingContact,
    }) &&
    emailsMatch(userEmail, savedFormValues?.contact?.email)
  ) {
    return {
      savedFormValues,
      resumedExistingContact,
      clearSnapshots: false,
    }
  }

  return {
    savedFormValues: null,
    resumedExistingContact: null,
    clearSnapshots: true,
  }
}

export default resolveEditJoinSignInSnapshots
